import type { AlertGroup } from '@d-orca/shared/alert-kinds';
import type { IAdminUser } from '@apis/adminUsers';

const TRUSSTOR_ADMIN = 'TRUSSTOR_ADMIN';

/**
 * The project's users the Hub offers as a group's recipients. Trusstor
 * administrators are listed only to one of them (Trusstor's rule); safety
 * alerts only to the members the server says may see safety (`safetyEligible`
 * — the role policy is the server's, never mirrored here).
 */
export function eligibleRecipients(
  users: IAdminUser[],
  group: AlertGroup,
  viewerIsTrusstorAdmin: boolean,
  safetyEligible: ReadonlySet<string>,
): IAdminUser[] {
  return users.filter(
    (u) => (viewerIsTrusstorAdmin || u.role !== TRUSSTOR_ADMIN) && (group !== 'safety' || safetyEligible.has(u.username)),
  );
}

/** A row's recipients the viewer can see — what "N recipients" counts. */
export function visibleRecipients(recipients: string[], eligible: IAdminUser[]): string[] {
  const listed = new Set(eligible.map((u) => u.username));
  return recipients.filter((u) => listed.has(u));
}
